"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoWrap = void 0;
var NoWrap = function (props) { return props.children; };
exports.NoWrap = NoWrap;
//# sourceMappingURL=no-wrap.js.map